import React from 'react';
import PlatformFooter from 'cccisd-footer';

const Footer = p => <PlatformFooter {...p} />;

export default Footer;
